import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
    openNewPage,
    getHostName,
    API_GET_ORDER_DETAILS,
} from "../modals/Constants";
import { getStorage } from "../modals/Storage";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import AlertDialog from "../dialogs/AlertDialog/dialog";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import HeaderView from "../other-components/HeaderView/view";
import Collapsible from "../other-components/CollapsibleView/CollapsibleView";

function Refund() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [deleteID, setDeleteID] = useState("");
    const [searchParams] = useSearchParams();
    const query = searchParams.get("q") || "";

    const [values, setConstants] = useState({
        totalOrderAmount: 0,
        productList: [],
        bankDetails: "",
        dataLoaded: false,
    });

    const [open, showDeleteAlert] = useState(false);

    const updateInput = (value) => {
        setConstants((prev) => ({
            ...prev,
            bankDetails: value,
        }));
    };

    const updateUIItems = (items) => {
        const productViews = items.map((data) => (
            <div className={screen.cartItem} key={data.item_id}>
                <img
                    className="w-100-p br-5"
                    src={data.item_media}
                    onClick={() => openNewPage(getHostName() + "/p/" + data.item_slug)}
                    alt={data.item_name}
                />

                <div className={screen.cartContentsView}>
                    <h6 className={screen.title}>{data.item_name}</h6>
                    <p className={screen.sizeView}>Size: {data.item_size}</p>
                    <h6 className={screen.pricingView}>₹{data.item_price}</h6>
                </div>
            </div>
        ));

        const totalAmount = items.reduce(
            (sum, item) => sum + parseFloat(item.item_price || 0),
            0
        );

        setConstants((prev) => ({
            ...prev,
            totalOrderAmount: totalAmount,
            productList: productViews,
        }));
    };

    async function loadRecords() {
        try {
            setLoading(true);

            const formData = {
                ACCOUNT_ID: getStorage("accountID"),
                ORDER_ID: query,
            };

            const res = await fetch(API_GET_ORDER_DETAILS, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${getStorage("accountSecret")}`,
                },
                body: JSON.stringify(formData),
            });

            const data = await res.json();
            setLoading(false);

            if (data.status_code === "success" && data.data?.length > 0) {
                updateUIItems(data.data);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error loading records:", error);
        }
    }

    const updateProduct = (cartID, addQuantity = false, isRemove = false) => {
        if (isRemove) {
            showDeleteAlert(false);
        }

        async function requestAPI(url, formData) {
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${getStorage("accountSecret")}`,
                    },
                    body: JSON.stringify(formData),
                });

                const data = await res.json();
                setLoading(false);

                if (data.status_code === "success") {
                    loadRecords();
                }
            } catch (error) {
                setLoading(false);
            }
        }

        if (cartID) {
            setLoading(true);
            const formData = {
                ACCOUNT_ID: getStorage("accountID"),
                CART_ID: cartID,
                CART_ADD_QUANTITY: addQuantity,
                CART_DELETE: isRemove,
            };
            requestAPI(API_GET_ORDER_DETAILS, formData);
        }
    };

    useEffect(() => {
        if (!query) return;
        if (!values.dataLoaded) {
            setConstants((prev) => ({ ...prev, dataLoaded: true }));
            loadRecords();
        }
    }, [query]);

    return (
        <div className={general.appView}>
            <LoadingDialog isOpen={loading} />

            <AlertDialog
                isOpen={open}
                title="Are you sure you want to remove this?"
                onClose={() => showDeleteAlert(false)}
                actions={[
                    { label: "No", variant: "neutral", onClick: () => showDeleteAlert(false) },
                    { label: "Yes, Remove", variant: "positive", onClick: () => updateProduct(deleteID, false, true) },
                ]}
            />

            <div className={general.appChildView}>
                <HeaderView screen={"myorders"} />

                <div className={general.appLocationViews}>
                    <p>My order details</p>
                </div>

                <div className={general.appContentsView}>
                    <div className={[screen.cartView, general.mgB100px].join(" ")}>
                        <div className={screen.contentsView}>
                            <Collapsible title="How can i get refund?" description="" defaultOpen={true} />
                            <Collapsible title="How long it takes to get refund?" className={[general.mgT10px]} description="" />
                            <Collapsible title="How long it takes to get refund?" className={[general.mgT10px]} description="" />
                            <Collapsible title="How long it takes to get refund?" className={[general.mgT10px]} description="" />
                        </div>

                        <div className={screen.overview}>
                            <p className={screen.title}>Order details</p>
                            <br />

                            <div className={screen.listView}>
                                <p>Quantity</p>
                                <p>1</p>
                            </div>

                            <div className={screen.listView}>
                                <p>Total amount</p>
                                <p className={screen.subTitle}>₹{values.totalOrderAmount}</p>
                            </div>


                            <br></br>
                            <p>Bank Details</p>
                            <div
                                className={[
                                    general.inpBoxOutline,
                                    general.inputTextArea,
                                    general.mgT10px,
                                ].join(" ")}
                            >
                                <textarea
                                    placeholder="Please enter your bank details"
                                    autoComplete="off"
                                    value={values.bankDetails}
                                    onChange={(e) => updateInput(e.target.value)}
                                />
                            </div>

                            <button
                                className={[general.primaryBtn, general.w100, general.mgT30px, general.rounded1x].join(" ")}>
                                Confirm Cancellation
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Refund;